import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const track = (event, path) =>
  axios
    .post(`${API}/track`, { event, path, referrer: document.referrer || "" })
    .catch(() => {});

export const submitLead = (data) => axios.post(`${API}/leads`, data);
